import {createRouter, createWebHistory} from 'vue-router';
import PresalePage from '../pages/PresalePage.vue';
import OrderPage from '../pages/OrderPage.vue';
import CommunityPage from '../pages/CommunityPage.vue';
import BuyNFTPage from '../pages/BuyNFTPage.vue';
import ResonancePage from '../pages/resonance/ResonancePage.vue';
import ResonanceDetailPage from '../pages/resonance/ResonanceDetailPage.vue';
import AssetsPage from '../pages/AssetsPage.vue';
import HomePage from '../pages/HomePage.vue';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/home',
			component: HomePage,
			name: 'HomePage'
		},
		{
			path: '/presale',
			component: PresalePage,
			name: 'PresalePage'
		},
		{
			path: '/order',
			component: OrderPage,
			name: 'order'
		},
		{
			path: '/community',
			component: CommunityPage,
			name: 'CommunityPage'
		},
		{
			path: '/nft',
			component: BuyNFTPage,
			name: 'nft'
		},
		{
			path: '/resonance',
			component: ResonancePage,
			name: 'resonance',
		},
		{
			path: '/resonance/detail',
			component: ResonanceDetailPage,
			name: 'resonanceDetail'
		},
		{
			path: '/assets',
			component: AssetsPage,
			name: 'assets'
		},
		{
			path: '/:pathMatch(.*)*',
			redirect: '/home'
		}
	]
});

export default router;